module.exports = __webpack_public_path__ + "img/guangDongMobile.9fb57268.png";